import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
  Container, SearchSorting,
} from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../components/Molecules/Card';
import * as query from './query.gql';
import { ChipFacet } from '../../../components/SearchKit/ChipFacet';
import { SearchFacets } from '../../../components/SearchKit/SearchFacets';

import './style.scss';
import SearchLoadMore from '../../../components/SearchKit/SearchLoadMore';
import SearchKitVNL from '../../../components/SearchKit';
import { SelectFacet } from '../../../components/SearchKit/SelectFacet';
import SearchResults from '../../../components/SearchKit/SearchResults';

const SearchItem = ({ item }) => {
  const classes = classNames('ParagraphResearchOverview__row col-12 col-md-6 col-lg-4');
  const title = item.fields.title[0];
  const bodyText = item.fields.summary;
  const url = item.fields.url[0];
  const status = item.fields.field_research_status_name[0];
  const publicationDate = new Date(item.fields.field_publication_date && item.fields.field_publication_date[0]);
  const unixTimestamp = publicationDate.getTime() / 1000;
  const subType = item.fields.field_research_type_name[0];

  return (
    <div className={classes}>
      <Card
        created={unixTimestamp}
        link={url}
        title={title}
        body={bodyText}
        type="onderzoek"
        subType={subType}
        status={status}
      />
    </div>
  );
};

const SearchHeader = ({ data }) => {
  return (
    <span />
  );
};

const ParagraphResearchOverview = ({ entity }) => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphResearchOverview">
      <Container>
        {/* SearchKit */}
        <SearchKitVNL
          query={query}
          pageSize={15}
          defaultSorting="publication_date"
        >
          {
            (data, loading) => (
              <>
                {data && (
                  <>
                    <div className="Search__results">
                      <div className="Search__results__filters__wrapper">
                        <div className="Search__results__filters">
                          <div className="Search__results__filters__items">
                            <span>Filter</span>
                            <SearchFacets data={data.research} loading={loading} facets={[ChipFacet, SelectFacet, SearchFacets]} />
                          </div>
                          <div className="Search__results__filters__sorting">
                            <span>{t('general.sort')}</span>
                            <SearchSorting data={data.research} loading={loading} />
                          </div>
                        </div>
                        <div className="total-count minimized">
                          {data.research.results.summary.total} {t('general.search_results')}
                        </div>
                      </div>
                    </div>
                    <SearchResults
                      data={data.research}
                      renderItem={SearchItem}
                      renderHeader={SearchHeader}
                      appendResults
                    />
                    <SearchLoadMore data={data ? data.research : null} />
                    {data.research.results.summary.total === 0 && (
                      <div className="alert alert-danger">
                        Er zijn geen onderzoeken gevonden voor uw zoekopdracht. Probeer het nogmaals.
                      </div>
                    )}
                  </>
                )}
              </>
            )
          }
        </SearchKitVNL>
      </Container>

    </div>
  );
};

export default ParagraphResearchOverview;
